// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__1T4RI","spinner_wrap":"styles_spinner_wrap__LIIk4"};